/**
=========================================================
* Modern Match Invite - v2.0.0
=========================================================
* A modern, responsive design for cricket match invites
* Built with React and Material-UI
=========================================================
*/

import axios from 'axios';  
import React from 'react';  
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import SoftInput from "components/SoftInput";
import { Box, Grid, Chip, Avatar, IconButton, Typography, Paper, Divider, Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

import gr_logo from "assets/images/group.png";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Helmet } from "react-helmet";
import FormSelect from 'react-bootstrap/FormSelect';

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbarNotLooged from "examples/Navbars/DashboardNavbarNotLooged";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import { useState, useRef} from 'react';
import {getPlayerProfile} from 'Utils.js'
import { FaImages, FaBasketballBall, FaMinusCircle, FaPenSquare, FaShare, FaPaypal, FaUserPlus, FaClock, FaUsers, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import AssignmentIcon from '@mui/icons-material/Assignment';

import Modal from 'react-modal';


import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { Navigate } from "react-router-dom";
import SoftButton from "components/SoftButton";
import Checkbox from "@mui/material/Checkbox";

import whatsapp_logo from "assets/images/logos/whatsapp.png";
import auction_hammer from "assets/images/auction_hammer.png";
import telegram_logo from "assets/images/logos/telegram.png";
import loader_img from "assets/images/loader.svg";

import 'App.css';

// Styled components for modern design
const HeroSection = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #F8F9FA 0%, #E9ECEF 50%, #DEE2E6 100%)',
  color: '#495057',
  padding: theme.spacing(6, 0),
  borderRadius: theme.spacing(2),
  marginBottom: theme.spacing(4),
  position: 'relative',
  overflow: 'hidden',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23495057" fill-opacity="0.08"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
    opacity: 0.6,
  }
}));

const PulseButton = styled(Button)(({ theme }) => ({
  animation: 'pulse 2s infinite',
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(76, 175, 80, 0.7)',
    },
    '70%': {
      boxShadow: '0 0 0 10px rgba(76, 175, 80, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(76, 175, 80, 0)',
    },
  },
}));

const ActionIconButton = styled(IconButton)(({ theme }) => ({
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'scale(1.15) rotate(5deg)',
  }
}));

const StatsCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(45deg, #f8f9fa 30%, #e9ecef 90%)',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
  textAlign: 'center',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  }
}));

const ParticipantCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  margin: theme.spacing(1, 0),
  borderRadius: theme.spacing(2),
  border: '1px solid #e0e0e0',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: theme.shadows[4],
    borderColor: theme.palette.primary.main,
  }
}));

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '12px',
    border: 'none',
    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
    maxWidth: '90vw',
    maxHeight: '90vh',
    overflow: 'auto'
  },
  overlay: {zIndex: 100000}   
};

const Spinner = () => (
  <img src={loader_img} className="zoom2" height="30"/>
);

function Author({ image, name, email }) {
  return (
    <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar src={image} alt={name} size="sm" variant="rounded" />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column" >
        <SoftTypography variant="button" fontWeight="medium" color="info">
          {name}
        </SoftTypography>
        <SoftTypography variant="caption" color="secondary">
          {email}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

function Function({ job, org }) {
  return (
    <SoftBox display="flex" flexDirection="column">
      <SoftTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </SoftTypography>
      <SoftTypography variant="caption" color="secondary">
        {org}
      </SoftTypography>
    </SoftBox>
  );
}

export default class Minew extends React.Component {  
  constructor(props) {
    super(props);
    this.setState({loggedIn: '1'});
    this.setState({showModal: false});
    this.setState({viewstatus: 'list'});
    this.ref_j_mobile_no = React.createRef();
    this.cropperRef = React.createRef();
    window.helloComponent = this;
    this.setCookieIfNotSet('cooUserID', 365);

    this.state = { 
      loggedIn: '1',
      showModal: false,
      viewstatus:'list',
      linkrows:[],
      groupname:'Friends Group',
      group_logo:team2,
      current_player_profile:'<h4>Player details</h4>',
      imageSrc: null,
      crop: {
        unit: '%',
        width: 80,
        height: 80,
        x: 10,
        y: 10
      },
      croppedImage: null,
      normalmembers: [],
      wl_members: [],
      guestmembers: [],
      searchTerm: '',
      filteredNormalMembers: [],
      filteredWlMembers: [],
      originalNormalData: [],
      originalWlData: [],
      is_admin: false
    };
  }

  onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1024 * 1024) {
        alert('File size should not exceed 1MB');
        e.target.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        console.log('Image uploaded successfully, base64 length:', reader.result.length);
        this.setState({ 
          imageSrc: reader.result,
          croppedImage: reader.result // Use the original image directly
        });
      };
      reader.readAsDataURL(file);
    }
  };





  handleChange = (event) => {
    this.setState({ c_icon_tex: event.target.value });
  };

  setCookieIfNotSet(cookieName, daysToExpire) {
    var existingCookie = this.getCookie(cookieName);
    
    if (!existingCookie) {
        var randomValue = this.generateRandomUniqueValue();
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + daysToExpire);
        var expires = "expires=" + expirationDate.toUTCString();
        document.cookie = `${cookieName}=${randomValue}; ${expires}; path=/`;
    }
  }

  getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
  }

  generateRandomUniqueValue() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
  }

  clickedAddMember(val_id,uname){
    localStorage.setItem("storedIUserName", uname);
    localStorage.setItem("storedIUserCode", val_id);
    const memberIdElement = document.getElementById('j_member_id');
    if (memberIdElement) {
      memberIdElement.value = val_id;
      console.log('Member ID set to:', val_id);
    } else {
      console.log('j_member_id element not found');
    }
    this.onClickAddLink();
  }

  clickedAddMemberC() {
    const memberIdElement = document.getElementById('j_member_id');
    if (memberIdElement) {
      memberIdElement.value = localStorage.getItem('storedIUserCode');
    }
    window.helloComponent.onClickAddLink();
  }

  clickedAddMemberQuick() {
    window.helloComponent.onClickAddLinkQuick();
  }

  scrollToJoinFormAndFocus() {
    setTimeout(() => {
      const joinForm = document.getElementById('join-form-container');
      if (joinForm) {
        joinForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Add a subtle highlight effect
        joinForm.style.transition = 'box-shadow 0.3s ease';
        joinForm.style.boxShadow = '0 0 20px rgba(76, 175, 80, 0.3)';
        setTimeout(() => {
          joinForm.style.boxShadow = '';
        }, 2000);
        // Focus on mobile number input
        const mobileInput = document.getElementById('j_mobile_no');
        if (mobileInput) {
          mobileInput.focus();
        }
      }
    }, 100);
  }

  closeshowVerify = (e) => {
    this.setState({ showVerify: false });
  }

  closeshowChangeType = (e) => {
    this.setState({ showChangeType: false });
  }

  onClickGenOTPR = (e) => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    var cooUserID = this.getCookie('cooUserID');
    const post_data = { invite_code: invite_code, series_participant_id:this.state.series_participant_id, cooUserID:cooUserID };

    axios.post(global.config.app.backend_api_url +`matchschedule/generate_remove_otp`, post_data, { 
      withCredentials: true,
      headers: { 'content-type': 'application/json' } 
    })  
    .then(res => {  
      alert(res.data.message);
      if(res.data.status=='1') {
        const modalClickElement = document.getElementById('i_remove_modal_click');
        const modalFormElement = document.getElementById('i_remove_modal_form');
        if (modalClickElement) modalClickElement.style.display='none';
        if (modalFormElement) modalFormElement.style.display='';
      }
    }).catch((error) => {
      console.log('response: ', error.response.data);
    });
  }

  onClickSwapPlayerBeforeAuction = (e) => {
    const mobileElement = document.getElementById('mi_e_new_user_mobile_number');
    var mi_e_new_user_mobile_number = mobileElement ? mobileElement.value : '';
    const swapElement = document.getElementById("michangeswapplayer");
    if (swapElement) swapElement.style.display="none";

    let search = window.location.search;
    let params = new URLSearchParams(search);
    const post_data = { 
      series_id: this.state.series_id, 
      new_user_mobile_number: mi_e_new_user_mobile_number,
      series_participant_id:this.state.series_participant_id
    };

    axios.post(global.config.app.backend_api_url + `auction/swap_player_before_auction_sell`, post_data, { withCredentials: true })
    .then(res => {
      const swapElement = document.getElementById("michangeswapplayer");
      if (swapElement) swapElement.style.display="";
      if (res.data.status == '0') {
        alert(res.data.message);
      } else {
        alert(res.data.message);
        if(res.data.status=='1') {
          window.location.reload();
        }
      }
    });
  }

  onClickMChangeType = (e) => {
    this.setState({error_msg: ''});
    const memberTypeElement = document.getElementById('mi_member_type');
    const isIconElement = document.getElementById('mi_is_icon');
    const iconTextElement = document.getElementById('mi_icon_text');
    const mi_member_type = memberTypeElement ? memberTypeElement.value : '';
    const mi_is_icon = isIconElement ? isIconElement.value : '';
    const mi_icon_text = iconTextElement ? iconTextElement.value : '';

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    var cooUserID = this.getCookie('cooUserID');
    const post_data = {
      mi_member_type:mi_member_type,
      mi_is_icon:mi_is_icon,
      mi_icon_text:mi_icon_text,
      invite_code: invite_code,
      series_participant_id:this.state.series_participant_id 
    };

    axios.post(global.config.app.backend_api_url +`matchschedule/change_participant_type`, post_data, { 
      withCredentials: true,
      headers: { 'content-type': 'application/json' } 
    })  
    .then(res => {  
      alert(res.data.message);
      if(res.data.status=='1') {
        window.location.reload();
      }
    }).catch((error) => {
      console.log('response: ', error.response.data);
    });
  }

  onRClickVerify = (e) => {
    this.setState({error_msg: ''});
    const otp = document.getElementById('rem_otp').value;

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    var cooUserID = this.getCookie('cooUserID');
    const post_data = {
      remove_otp_flow:1, 
      invite_code: invite_code,
      series_participant_id:this.state.series_participant_id,
      cooUserID:cooUserID,
      remove_otp:otp 
    };

    axios.post(global.config.app.backend_api_url +`matchschedule/remove_participant`, post_data, { 
      withCredentials: true,
      headers: { 'content-type': 'application/json' } 
    })  
    .then(res => {  
      alert(res.data.message);
      if(res.data.status=='1') {
        window.location.reload();
      }
    }).catch((error) => {
      console.log('response: ', error.response.data);
      this.setState({error_msg: error.response.data.message});
    });
  }

  showModal (group_fk,user_fk) {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    getPlayerProfile(group_fk,user_fk,'i_profile_modal',invite_code);
    this.setState({ show: !this.state.show });
  }

  closeModal = e => {
    this.setState({ show: false });
  }

  componentDidMount() { 
    this.getbasicajax();
  }

  getbasicajax() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    var cooUserID = this.getCookie('cooUserID');
    const post_data = { invite_code: invite_code, cooUserID:cooUserID };
    
    axios.post(global.config.app.backend_api_url + `matchschedule/getbyinvite_code`, post_data, { withCredentials: true })  
    .then(res => {  
      var storedIUserName = localStorage.getItem("storedIUserName");
      var storedIUserCode = localStorage.getItem("storedIUserCode");
      
      this.setState({
        user_id: res.data.user_id,
        groupname:res.data.link_data[0].group_name,
        group_admin_flag : res.data.link_data[0].is_admin,
        is_admin: res.data.link_data[0].is_admin === '1' || res.data.link_data[0].is_admin === 1 || res.data.link_data[0].is_admin === true,
        series_id : res.data.link_data[0].series_id,
        series_name : res.data.link_data[0].series_name,
        match_date : res.data.link_data[0].match_date,
        match_date_name:res.data.link_data[0].match_date_name,
        show_join_link_group_members_only:res.data.link_data[0].show_join_link_group_members_only,
        from_time : res.data.link_data[0].from_time,
        to_time : res.data.link_data[0].to_time,
        header_description : res.data.link_data[0].header_description,
        footer_description : res.data.link_data[0].footer_description,
        total_participants : res.data.link_data[0].total_participants,
        total_waiting_list : res.data.link_data[0].total_waiting_list,
        total_guests_participants: res.data.link_data[0].total_guests_participants,
        add_delete_permission_cutoff_time : res.data.link_data[0].add_delete_permission_cutoff_time,
        group_id : res.data.link_data[0].group_id,
        joined_flag : res.data.link_data[0].joined_flag,
        remaining_slots : res.data.link_data[0].remaining_slots,
        show_link  : res.data.link_data[0].show_link,
        status_name : res.data.link_data[0].status_name,
        group_logo : res.data.link_data[0].group_logo,
        storedIUserName:storedIUserName,
        storedIUserCode:storedIUserCode,
        photo_upload  : res.data.link_data[0].photo_upload,
        selected_player_photo:'',
        missing_sl  : res.data.missing_sl,
        description: res.data.link_data[0].description || ''
      });

      this.setState({
        og_title : res.data.link_data[0].group_name + ' - '+res.data.link_data[0].series_name + ' - '+res.data.link_data[0].match_date,
        og_description : res.data.link_data[0].remaining_slots +' slots remaining at '+ res.data.link_data[0].group_name + ' - '+res.data.link_data[0].series_name + ' - '+res.data.link_data[0].match_date
      });

      const normalmembers = this.createMemberRows(res.data.players_list);
      this.setState({ 
        normalmembers,
        filteredNormalMembers: normalmembers,
        originalNormalData: res.data.players_list
      });  
      
      const wl_members = this.createMemberRows(res.data.wl_players_list);
      this.setState({ 
        wl_members,
        filteredWlMembers: wl_members,
        originalWlData: res.data.wl_players_list
      });  

      if(res.data.user_details.user_id!='') {
        this.callNotificationSubscribe(res.data.user_details.nai,res.data.user_details.user_id);
      }
    });
  }

  callNotificationSubscribe(appid,userid) {
    if(userid=='' || appid=='') {
      return;
    }
    return;
    const s = document.createElement("script")
    s.src = "https://notix.io/ent/current/enot.min.js"
    s.onload = (sdk) => {
        sdk.startInstall({
            appId: appid,
            loadSettings: true,
            disableConsoleDebug: true,
            user: userid
        });
    }
    document.head.append(s);
  }

  onKeyDownSearch = (e) => {
    const j_mobile_no = document.getElementById('j_mobile_no').value;
    const memberIdElement = document.getElementById('j_member_id');
    if (memberIdElement) {
      memberIdElement.value = '';
    }
    this.ref_j_mobile_no.current = j_mobile_no;

    // Show loading state
    const membersListElement = document.getElementById("j_members_list");
    if (j_mobile_no.length >= 3) {
      membersListElement.innerHTML = `
        <div style="
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          padding: 32px 20px;
          margin-top: 16px;
          text-align: center;
          color: #7f8c8d;
        ">
          <div style="
            width: 40px;
            height: 40px;
            border: 3px solid #f3f3f3;
            border-top: 3px solid #6C757D;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 16px;
          "></div>
          <div style="font-size: 14px; font-weight: 500;">Searching members...</div>
        </div>
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `;
    } else {
      membersListElement.innerHTML = '';
      return;
    }

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    const post_data = { mobile_no: j_mobile_no, invite_code : invite_code };
      
    axios.post(global.config.app.backend_api_url + `members/search`, post_data, { withCredentials: true })  
    .then(res => {  
      const membersListElement = document.getElementById("j_members_list");
      
      if(res.data.status!='0') {
        let html_content = `
          <div style="
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.1);
            overflow: hidden;
            margin-top: 16px;
          ">
            <div style="
              background: linear-gradient(135deg, #F8F9FA 0%, #E9ECEF 50%, #DEE2E6 100%);
              color: #495057;
              padding: 16px 20px;
              font-weight: bold;
              font-size: 14px;
              display: flex;
              align-items: center;
              gap: 8px;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
              border-bottom: 1px solid #E9ECEF;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              Found ${res.data.length} member${res.data.length > 1 ? 's' : ''}
            </div>
        `;
        
        for(let iloop = 0; iloop < res.data.length; iloop++){
          const full_name = res.data[iloop].full_name;
          const mobile_no = res.data[iloop].mobile_no;
          const m_user_id = res.data[iloop].user_id;
          const profile_pic = res.data[iloop].profile_pic;
          const defaultAvatar = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFNUU3RUIiLz4KPHBhdGggZD0iTTIwIDEwQzIyLjIwOTEgMTAgMjQgMTEuNzkwOSAyNCAxNEMyNCAxNi4yMDkxIDIyLjIwOTEgMTggMjAgMThDMTcuNzkwOSAxOCAxNiAxNi4yMDkxIDE2IDE0QzE2IDExLjc5MDkgMTcuNzkwOSAxMCAyMCAxMFoiIGZpbGw9IiM5Q0EzQUYiLz4KPHBhdGggZD0iTTI4IDMwQzI4IDI2LjY4NjMgMjQuNDE4MyAyNCAyMCAyNEMxNS41ODE3IDI0IDEyIDI2LjY4NjMgMTIgMzBIMjhaIiBmaWxsPSIjOUNBM0FGIi8+Cjwvc3ZnPgo=';

          html_content += `
            <div style="
              display: flex;
              align-items: center;
              padding: 16px 20px;
              border-bottom: 1px solid #f0f0f0;
              transition: all 0.3s ease;
              cursor: pointer;
              ${iloop === res.data.length - 1 ? 'border-bottom: none;' : ''}
            " onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">
              
              <div style="
                width: 48px;
                height: 48px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 16px;
                flex-shrink: 0;
                border: 2px solid #e3f2fd;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
              ">
                <img src="${profile_pic || defaultAvatar}" 
                     alt="${full_name}" 
                     style="
                       width: 100%;
                       height: 100%;
                       object-fit: cover;
                       ${!profile_pic ? 'filter: grayscale(1);' : ''}
                     "
                     onerror="this.src='${defaultAvatar}'"
                />
              </div>
              
              <div style="flex: 1; min-width: 0;">
                <div style="
                  font-weight: 600;
                  color: #2c3e50;
                  font-size: 16px;
                  margin-bottom: 4px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                ">${full_name}</div>
                <div style="
                  color: #7f8c8d;
                  font-size: 14px;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                ">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                  </svg>
                  ${mobile_no}
                </div>
              </div>
              
              <button onclick="window.helloComponent.clickedAddMember('${m_user_id}','${full_name}')" 
                      style="
                        background: linear-gradient(45deg, #4CAF50 30%, #45a049 90%);
                        color: white;
                        border: none;
                        border-radius: 20px;
                        padding: 8px 16px;
                        font-size: 13px;
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                      "
                      onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(76, 175, 80, 0.4)'"
                      onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(76, 175, 80, 0.3)'"
              >
                Add
              </button>
            </div>
          `;
        }
        
        html_content += '</div>';
        membersListElement.innerHTML = html_content;
      } else {
        membersListElement.innerHTML = `
          <div style="
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.1);
            padding: 32px 20px;
            margin-top: 16px;
            text-align: center;
            color: #7f8c8d;
          ">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" style="margin-bottom: 16px; opacity: 0.5;">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <div style="font-size: 16px; font-weight: 500; margin-bottom: 8px;">No members found</div>
            <div style="font-size: 14px; opacity: 0.7;">Try searching with a different mobile number</div>
          </div>
        `;
      }
    });
  }

  onClickNotify = (e) => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    const post_data = { invite_code : invite_code };
    
    axios.post(global.config.app.backend_api_url + `matchschedule/sendnotification`, post_data, { withCredentials: true })  
    .then(res => {  
      alert(res.data.message);
    });
  }

  backButtonClick = (e) => {
    this.getbasicajax();
    this.setState({
      viewstatus: 'list',
      imageSrc: null,
      croppedImage: null,
      searchTerm: ''
    });
  }

  ondMIImageChange = event => {
    var cooUserID = this.getCookie('cooUserID');
    var j_photo_upload = '';
    try {
      j_photo_upload = this.state.croppedImage;
      console.log('Profile photo upload data length:', j_photo_upload ? j_photo_upload.length : 0);
    } catch(Err) {
      console.log('Error getting croppedImage for profile:', Err);
    }

    const post_data = { 
      midp_member_id: this.state.selected_member,
      cooUserID : cooUserID,
      profile_image:j_photo_upload
    };

    axios.post(global.config.app.backend_api_url + `members/uploadprofilepic_byadmin_fromlink_new`, post_data, { withCredentials: true })  
    .then(res => {  
      if(res.data.status=='0') {
        alert(res.data.message);
      } else {
        alert(res.data.message);
        this.setState({ viewstatus: 'list'});
      }
    });
  }

  ondMIICricmageChange = event => {
    const formData = new FormData();
    const profileLinkElement = document.getElementById('micricdp_profile_pic_link');
    const profileLink = profileLinkElement ? profileLinkElement.value : '';
    formData.append("profile_link", profileLink);
    formData.append("midp_member_id", this.state.selected_member);
    var cooUserID = this.getCookie('cooUserID');
    formData.append("cooUserID", cooUserID);
      
    axios.post(global.config.app.backend_api_url + `members/update_cric_profilelink_byadmin_fromlink`, formData, { withCredentials: true })  
    .then(res => {  
      if(res.data.status=='0') {
        alert(res.data.message);
      } else {
        alert(res.data.message);
        this.setState({ viewstatus: 'list'});
      }
    });
  }

  getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      return reader.result;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  onClickAddLinkQuick = (e) => {
    this.setState({loader_join: true});
    var j_mobile_no = '';
    this.ref_j_mobile_no.current = j_mobile_no;
    var j_member_id = '';
    var j_full_name = '';

    try {
      j_full_name = '';
    } catch(Err) {}

    try {
      j_member_id = localStorage.getItem('storedIUserCode');
    } catch(Err) {}



    var j_photo_upload = '';
    try {
      j_photo_upload = this.state.croppedImage;
      console.log('Quick join photo upload data length:', j_photo_upload ? j_photo_upload.length : 0);
    } catch(Err) {
      console.log('Error getting croppedImage for quick join:', Err);
    }
  
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');
    var cooUserID = this.getCookie('cooUserID');

    const post_data = { 
      member_mobile_no: j_mobile_no,
      invite_code : invite_code,
      member_name:j_full_name,
      member_id:j_member_id,
      cooUserID:cooUserID,
      photo_upload:j_photo_upload
    };

    axios.post(global.config.app.backend_api_url + `matchschedule/add_participant`, post_data, { withCredentials: true })  
    .then(res => {  
      if(res.data.status=='0') {
        alert(res.data.message);
      } else {
        alert(res.data.message);
      }
      this.setState({loader_join: false});
      window.location.reload();
    });
  }

  onClickAddLink = (e) => {
    this.setState({loader_join: true});
    var j_mobile_no = document.getElementById('j_mobile_no').value;
    this.ref_j_mobile_no.current = j_mobile_no;
    var j_member_id = '';
    var j_keep_checked = document.getElementById('j_keep').checked;
    var j_full_name = '';

    try {
      j_full_name = document.getElementById('j_full_name').value;
    } catch(Err) {}

    try {
      j_member_id = document.getElementById('j_member_id').value;
    } catch(Err) {}

    var j_photo_upload = '';
    try {
      j_photo_upload = this.state.croppedImage;
      console.log('Join photo upload data length:', j_photo_upload ? j_photo_upload.length : 0);
    } catch(Err) {
      console.log('Error getting croppedImage for join:', Err);
    }

      let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');
    var cooUserID = this.getCookie('cooUserID');

    const post_data = { 
      member_mobile_no: j_mobile_no,
      invite_code : invite_code,
      member_name:j_full_name,
      member_id:j_member_id,
      cooUserID:cooUserID,
      photo_upload:j_photo_upload
    };

    axios.post(global.config.app.backend_api_url + `matchschedule/add_participant`, post_data, { withCredentials: true })  
    .then(res => {  
      if(res.data.status=='0') {
        alert(res.data.message);
      } else {
        alert(res.data.message);
        document.getElementById('j_mobile_no').value = '';
        try {
          document.getElementById('j_full_name').value = '';
        } catch(Err) {}
        try {
          document.getElementById('j_member_id').value = '';
        } catch(Err) {}
        if(!j_keep_checked) {
          this.getbasicajax();
          this.setState({viewstatus: 'list'});
        }
      }
      this.setState({loader_join: false, croppedImage: null,imageSrc:null});
    });
  }

  deleteRow(id, name, e) {  
    if(window.confirm('Remove '+name+' ?')===false) {
      return false;
    }
    
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invite_code = params.get('i');

    var cooUserID = this.getCookie('cooUserID');
    const post_data = { invite_code: invite_code, series_participant_id:id, cooUserID:cooUserID };
     
    axios.post(global.config.app.backend_api_url + `matchschedule/remove_participant`, post_data, { withCredentials: true })  
    .then(res => {  
      if(res.data.status=='0') {
        alert(res.data.message);
        if(res.data.pop_flag=='1') {
          this.setState({pop_message:res.data.pop_msg, series_participant_id:id, showVerify: true});
        }
      } else {
        alert(res.data.message);
        window.location.reload();
      }
    });
  }

  membersTableColumns = {
    member_columns : [
      { name: "slno", align: "left" },
      { name: "member_name", align: "left" },
      { name: "mobile_no", align: "left" },
      { name: "added_on", align: "left" },
      { name: "action", align: "left" },
    ]
  }

  createMemberRows(res) {
    const plainObj = [];

    var iloop;
    for(iloop=0; iloop < res.length; iloop++){
      const thisid = res[iloop].id;
      const g_user_fk = res[iloop].series_participant_reg_user_fk;
      const g_group_fk = res[iloop].group_fk;
      const series_participant_id= res[iloop].series_participant_id;
      const participant_member_type= res[iloop].participant_member_type;
      const s_sl_no = res[iloop].sl_no;
      const ppic = res[iloop].profile_pic;
      const allow_pic_upload_by_gr_admin  = res[iloop].allow_pic_upload_by_gr_admin;
      const is_icon= res[iloop].is_icon;
      const icon_text= res[iloop].icon_text;

      var icon_new_flag   = '';
      var ff= 0 ;

      if(is_icon  ==  '1' || icon_text!='') {
        icon_new_flag = ' (';
        ff  = 1;
      }

      if(is_icon  ==  '1') {
        icon_new_flag = icon_new_flag+' ICON/OWNER';
      }

      if(icon_text  !=  '') {
        icon_new_flag = icon_new_flag +':'+icon_text ;
      }

      if(ff==1) {
        icon_new_flag = icon_new_flag+' )';
      }
      
      const total_participants= res[iloop].total_participants;
      const total_guests_participants= res[iloop].total_guests_participants;
      const const_member_name = res[iloop].player_name;
      const allow_cricheroes_pic_upload_by_gr_admin = res[iloop].allow_cricheroes_pic_upload_by_gr_admin;
      const cric_heroes_profile_img = res[iloop].cric_heroes_profile_img;
      const cric_heroes_profile_link= res[iloop].cric_heroes_profile_link;

      var guest_flag = '';
      if(total_participants !== total_guests_participants && participant_member_type ==  '2') {
        guest_flag  = '(G)';
      }

      const arrayLike = {
        slno: <Function job={s_sl_no}  />,
        member_name: (
          <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
            <SoftBox mr={2}>
              <SoftAvatar src={res[iloop].profile_pic ? (res[iloop].profile_pic):(team2)} alt={res[iloop].player_name} size="sm" variant="rounded" />
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" >
              <SoftTypography component="a" href="javascript:void(0)"  onClick={() => this.showModal(g_group_fk,g_user_fk)} variant="button" fontWeight="medium" color="info">
                {res[iloop].player_name} {guest_flag} {icon_new_flag}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        ),
        mobile_no: <Function job={res[iloop].mobile_no}  />,
        added_on: <Function job={res[iloop].added_on}  />,
        'added_on': res[iloop].added_on,
        'action' : (
          <SoftBox display="flex" gap={1} alignItems="center">
            {(() =>{
              if(res[iloop].del_flag == '1' ) {
                var s_cap = 'Change type for '+res[iloop].player_name;
                return(
                  <ActionIconButton
                    size="small"
                    title="Edit"
                    onClick={() => this.setState({showChangeType:true,c_is_icon:is_icon,c_icon_tex:icon_text, c_participant_member_type:participant_member_type,change_pop_message:s_cap,series_participant_id:series_participant_id})}
                    sx={{
                      color: '#2196F3',
                      backgroundColor: 'rgba(33, 150, 243, 0.1)',
                      borderRadius: '8px',
                      padding: '8px',
                      '&:hover': {
                        backgroundColor: 'rgba(33, 150, 243, 0.2)',
                        boxShadow: '0 2px 8px rgba(33, 150, 243, 0.3)',
                      }
                    }}
                  >
                    <FaPenSquare size={18} />
                  </ActionIconButton>
                )
              }
            })()}

            {(() =>{
              if((res[iloop].del_flag == '1' && allow_pic_upload_by_gr_admin=='1' && ppic== '') || res[iloop].always_dp=='1') {
                return(
                  <ActionIconButton
                    size="small"
                    title="Upload Pic"
                    onClick={() => this.setState({
                      viewstatus: 'uploaduserdp',
                      selected_member:g_user_fk,
                      selected_member_name:const_member_name,
                      imageSrc: null,
                      croppedImage: null
                    })}
                    sx={{
                      color: '#FF9800',
                      backgroundColor: 'rgba(255, 152, 0, 0.1)',
                      borderRadius: '8px',
                      padding: '8px',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 152, 0, 0.2)',
                        boxShadow: '0 2px 8px rgba(255, 152, 0, 0.3)',
                      }
                    }}
                  >
                    <FaImages size={18} />
                  </ActionIconButton>
                )
              }
            })()}

            {(() =>{
              if(cric_heroes_profile_link == '') {
                return(
                  <ActionIconButton
                    size="small"
                    title="Update CricHeroes Profile link"
                    onClick={() => this.setState({viewstatus: 'uploadusercricdp',selected_member:g_user_fk,selected_member_name:const_member_name})}
                    sx={{
                      color: '#4CAF50',
                      backgroundColor: 'rgba(76, 175, 80, 0.1)',
                      borderRadius: '8px',
                      padding: '8px',
                      '&:hover': {
                        backgroundColor: 'rgba(76, 175, 80, 0.2)',
                        boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)',
                      }
                    }}
                  >
                    <FaBasketballBall size={18} />
                  </ActionIconButton>
                )
              }
            })()}

            {(() => {
              if(res[iloop].del_flag == '1') {
                var player_name = res[iloop].player_name;
                return (
                  <ActionIconButton
                    size="small"
                    title="Delete"
                    onClick={() => this.deleteRow(series_participant_id , player_name)}
                    sx={{
                      color: '#F44336',
                      backgroundColor: 'rgba(244, 67, 54, 0.1)',
                      borderRadius: '8px',
                      padding: '8px',
                      '&:hover': {
                        backgroundColor: 'rgba(244, 67, 54, 0.2)',
                        boxShadow: '0 2px 8px rgba(244, 67, 54, 0.3)',
                      }
                    }}
                  >
                    <FaMinusCircle size={18} />
                  </ActionIconButton>
                )
              }
            })()}
          </SoftBox>
        ),
        'id' : res[iloop].id
      };
      Array.prototype.push.call(plainObj, arrayLike);
    }
    
    return plainObj;
  }

  handleSearchChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    this.setState({ searchTerm }, () => {
      this.filterMembers();
    });
  };

  filterMembers = () => {
    const { searchTerm, normalmembers, wl_members, originalNormalData, originalWlData } = this.state;
    
    if (!searchTerm.trim()) {
      this.setState({
        filteredNormalMembers: normalmembers,
        filteredWlMembers: wl_members
      });
      return;
    }

    const searchLower = searchTerm.toLowerCase();

    // Filter original data first, then create table rows from filtered data
    const filterOriginalData = (originalData) => {
      return originalData.filter(member => {
        const slno = member.sl_no?.toString().toLowerCase() || '';
        const memberName = member.player_name?.toLowerCase() || '';
        const mobileNo = member.mobile_no?.toString().toLowerCase() || '';
        
        return slno.includes(searchLower) || 
               memberName.includes(searchLower) || 
               mobileNo.includes(searchLower);
      });
    };

    const filteredNormalData = filterOriginalData(originalNormalData);
    const filteredWlData = filterOriginalData(originalWlData);

    // Create table rows from filtered data
    const filteredNormalMembers = this.createMemberRows(filteredNormalData);
    const filteredWlMembers = this.createMemberRows(filteredWlData);

    this.setState({
      filteredNormalMembers,
      filteredWlMembers
    });
  };

  render() {  
    const { member_columns } = this.membersTableColumns;

    return (  
      <DashboardLayout>
        <Helmet>
          <title>Match Invite | {global.config.app.name}</title>
          <meta
            name="description"
            content="Join Our Cricket Team - Experience the thrill of competitive cricket and be part of a supportive community. Sign up now and showcase your skills on the field."
          />
          <meta
            name="keywords"
            content="Cricket, team, join, competitive, skills, community, sign up, field"
          />
          <meta property="og:title" content={this.state.og_title} />
          <meta property="og:description" content={this.state.og_description}/>
        </Helmet>
        
        <DashboardNavbarNotLooged />
        
        <SoftBox py={3}>
          {/* Hero Section */}
          <HeroSection sx={{ position: 'relative' }}>
            {/* Admin Requests Button */}
            {this.state.is_admin && (
              <Button
                variant="contained"
                size="small"
                startIcon={<AssignmentIcon />}
                onClick={() => {
                  const urlParams = new URLSearchParams(window.location.search);
                  const seriesKey = urlParams.get('s');
                  window.location.href = `/registration-requests?s=${this.state.series_id}`;
                }}
                sx={{
                  position: 'absolute',
                  right: 24,
                  top: 24,
                  zIndex: 10,
                  backgroundColor: 'rgba(25, 118, 210, 0.9)',
                  color: 'white',
                  fontWeight: 600,
                  textTransform: 'none',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 1)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                  }
                }}
              >
                Requests
              </Button>
            )}
            
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={8}>
                <Box display="flex" alignItems="center" mb={2}>
                  <Avatar
                    src={this.state.group_logo ? this.state.group_logo : gr_logo}
                    alt="Group Logo"
                    sx={{ width: 80, height: 80, mr: 3, border: '3px solid white' }}
                  />
                  <Box>
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                      {this.state.groupname}
                    </Typography>
                                         <Typography variant="h6" sx={{ opacity: 0.9 }}>
                       {this.state.series_name || 'Loading...'}
                     </Typography>
                  </Box>
                </Box>
                
                <Grid container spacing={2} mb={3}>
                  <Grid item xs={6} sm={3}>
                    <Box display="flex" alignItems="center">
                      <FaCalendarAlt style={{ marginRight: 8, opacity: 0.8 }} />
                                             <Typography variant="body2">
                         {this.state.match_date || 'Loading...'}
                       </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Box display="flex" alignItems="center">
                      <FaClock style={{ marginRight: 8, opacity: 0.8 }} />
                                             <Typography variant="body2">
                         {this.state.from_time || 'Loading...'}
                       </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Box display="flex" alignItems="center">
                      <FaUsers style={{ marginRight: 8, opacity: 0.8 }} />
                                             <Typography variant="body2">
                         {this.state.remaining_slots || 0} slots left
                       </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                                         <Chip 
                       label={this.state.status_name || 'Loading...'} 
                       color={this.state.show_link === '1' ? 'success' : 'error'}
                       variant="filled"
                     />
                  </Grid>
                </Grid>
              </Grid>
              
              <Grid item xs={12} md={4} textAlign="center">
                {this.state.show_link === '1' ? (
                  <PulseButton
                    variant="contained"
                    size="large"
                    startIcon={<FaUserPlus />}
                    onClick={() => {
                      this.setState({
                        viewstatus: 'create',
                        member_type:'1',
                        member_type_name:'Normal member',
                        imageSrc: null,
                        croppedImage: null
                      }, () => {
                        this.scrollToJoinFormAndFocus();
                      });
                    }}
                    sx={{
                      background: 'linear-gradient(45deg, #4CAF50 30%, #45a049 90%)',
                      color: 'white',
                      fontSize: '1.2rem',
                      fontWeight: 'bold',
                      padding: '14px 36px',
                      borderRadius: '30px',
                      boxShadow: '0 6px 20px rgba(76, 175, 80, 0.5)',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      border: '2px solid rgba(255,255,255,0.3)',
                      '&:hover': {
                        background: 'linear-gradient(45deg, #45a049 30%, #4CAF50 90%)',
                        transform: 'translateY(-3px)',
                        boxShadow: '0 8px 25px rgba(76, 175, 80, 0.7)',
                        border: '2px solid rgba(255,255,255,0.5)',
                      }
                    }}
                  >
                    Join Match
                  </PulseButton>
                ) : (
                  <Typography variant="h6" color="error" sx={{ fontWeight: 'bold' }}>
                    Registration Closed
                  </Typography>
                )}
                
                {/* Quick Join Button */}
                {this.state.storedIUserName && this.state.storedIUserName !== '' && this.state.show_link === '1' && (
                  <Box mt={2}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={this.clickedAddMemberQuick}
                      sx={{
                        color: '#495057',
                        borderColor: 'white',
                        '&:hover': {
                          borderColor: 'white',
                          backgroundColor: 'rgba(255,255,255,0.1)',
                        }
                      }}
                    >
                      Quick Join: {this.state.storedIUserName}
                    </Button>
                  </Box>
                )}
              </Grid>
            </Grid>
          </HeroSection>

          {/* Stats Cards */}
          <Grid container spacing={3} mb={4}>
            <Grid item xs={12} sm={6} md={3}>
              <StatsCard>
                                   <Typography variant="h4" color="primary" fontWeight="bold">
                     {this.state.total_participants || 0}
                   </Typography>
                <Typography variant="body2" color="textSecondary">
                  Max Participants
                </Typography>
              </StatsCard>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <StatsCard>
                                   <Typography variant="h4" color="success" fontWeight="bold">
                     {this.state.remaining_slots || 0}
                   </Typography>
                <Typography variant="body2" color="textSecondary">
                  Available Slots
                </Typography>
              </StatsCard>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <StatsCard>
                                   <Typography variant="h4" color="warning" fontWeight="bold">
                     {this.state.total_waiting_list || 0}
                   </Typography>
                <Typography variant="body2" color="textSecondary">
                  Waiting List
                </Typography>
              </StatsCard>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <StatsCard>
                                   <Typography variant="h4" color="info" fontWeight="bold">
                     {this.state.total_guests_participants || 0}
                   </Typography>
                <Typography variant="body2" color="textSecondary">
                  Guest Quota
                </Typography>
              </StatsCard>
            </Grid>
          </Grid>

          {/* Match Details Card */}
          <Card sx={{ mb: 4, borderRadius: 3, overflow: 'hidden' }}>
            <Box sx={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', p: 3 }}>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                Match Details
              </Typography>
            </Box>
            <Box p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Box mb={2}>
                    <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                      Date & Time
                    </Typography>
                    <Typography variant="body1" fontWeight="medium">
                      {this.state.match_date}, {this.state.match_date_name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {this.state.from_time} - {this.state.to_time}
                    </Typography>
                  </Box>
                  
                  <Box mb={2}>
                    <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                      Cut-off Time
                    </Typography>
                    <Typography variant="body1" fontWeight="medium">
                      {this.state.add_delete_permission_cutoff_time}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box mb={2}>
                    <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                      Description
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                      {this.state.header_description}
                      {this.state.footer_description && (
                        <>
                          <br />
                          {this.state.footer_description}
                        </>
                      )}
                    </Typography>
                  </Box>
                  
                  {this.state.missing_sl && (
                    <Box>
                      <Chip 
                        label={`Free slots: ${this.state.missing_sl}`} 
                        color="warning" 
                        variant="outlined"
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Card>

          {/* Admin Actions */}
          {this.state.group_admin_flag === '1' && (
            <Card sx={{ mb: 4, borderRadius: 3 }}>
              <Box p={3}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Admin Actions
                </Typography>
                <Box display="flex" gap={2} flexWrap="wrap">
                  <Button
                    variant="contained"
                    startIcon={<FaShare style={{ color: 'white', fontSize: '18px' }} />}
                    onClick={this.onClickNotify}
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: '#0d47a1',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      padding: '10px 20px',
                      boxShadow: '0 2px 8px rgba(13, 71, 161, 0.3)',
                      '&:hover': {
                        backgroundColor: '#002171',
                        boxShadow: '0 4px 12px rgba(13, 71, 161, 0.4)',
                      }
                    }}
                  >
                    Send Notification
                  </Button>
                  
                  <Link to={`/makeauction?id=${btoa(this.state.group_id)}&sid=${btoa(this.state.series_id)}`}>
                    <Button
                      variant="contained"
                      startIcon={<img src={auction_hammer} width="18" height="18" style={{ filter: 'brightness(0) invert(1)' }} />}
                      sx={{ 
                        borderRadius: 2,
                        backgroundColor: '#e65100',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        padding: '10px 20px',
                        boxShadow: '0 2px 8px rgba(230, 81, 0, 0.3)',
                        '&:hover': {
                          backgroundColor: '#bf360c',
                          boxShadow: '0 4px 12px rgba(230, 81, 0, 0.4)',
                        }
                      }}
                    >
                      Auction
                    </Button>
                  </Link>
                  
                  <Link to={`/viewmembers?id=${btoa(this.state.group_id)}&sid=${btoa(this.state.series_id)}`}>
                    <Button
                      variant="contained"
                      startIcon={<FaPenSquare style={{ color: 'white', fontSize: '18px' }} />}
                      sx={{ 
                        borderRadius: 2,
                        backgroundColor: '#2e7d32',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        padding: '10px 20px',
                        boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                        '&:hover': {
                          backgroundColor: '#1b5e20',
                          boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                        }
                      }}
                    >
                      Edit Link
                    </Button>
                  </Link>
                  
                  <Link to={`/mi/plain?i=${new URLSearchParams(window.location.search).get('i')}`}>
                    <Button
                      variant="contained"
                      startIcon={<img src={whatsapp_logo} width="18" height="18" style={{ filter: 'brightness(0) invert(1)' }} />}
                      sx={{ 
                        borderRadius: 2,
                        backgroundColor: '#25d366',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        padding: '10px 20px',
                        boxShadow: '0 2px 8px rgba(37, 211, 102, 0.3)',
                        '&:hover': {
                          backgroundColor: '#128c7e',
                          boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
                        }
                      }}
                    >
                      Share
                    </Button>
                  </Link>
                  
                  <Button
                    variant="contained"
                    startIcon={<span style={{ fontWeight: 'bold', fontSize: '16px', color: 'white' }}>PDF</span>}
                    onClick={() => {
                      const inviteCode = new URLSearchParams(window.location.search).get('i');
                      const pdfUrl = `${process.env.REACT_APP_BACKEND_API_URL}/share_player_cards/share?series_code=${inviteCode}&cric=0&pdf=1&dd=`+ new Date().getTime();
                      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
                    }}
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: '#c62828',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      padding: '10px 20px',
                      boxShadow: '0 2px 8px rgba(198, 40, 40, 0.3)',
                      '&:hover': {
                        backgroundColor: '#b71c1c',
                        boxShadow: '0 4px 12px rgba(198, 40, 40, 0.4)',
                      }
                    }}
                  >
                    Player
                  </Button>
                </Box>
              </Box>
            </Card>
          )}

          {/* Main Content */}
          <SoftBox mb={3}>
            {this.state.viewstatus === 'list' ? (
              <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', p: 3 }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5" fontWeight="bold" color="white">
                      Participants List
                    </Typography>
                    {this.state.show_link === '1' && (
                      <Button
                        variant="contained"
                        startIcon={<FaUserPlus />}
                        onClick={() => {
                          this.setState({
                            viewstatus: 'create',
                            member_type:'1',
                            member_type_name:'Normal member',
                            imageSrc: null,
                            croppedImage: null
                          }, () => {
                            this.scrollToJoinFormAndFocus();
                          });
                        }}
                        sx={{
                          background: 'linear-gradient(45deg, #4CAF50 30%, #45a049 90%)',
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '0.9rem',
                          padding: '8px 20px',
                          borderRadius: '20px',
                          boxShadow: '0 4px 15px rgba(76, 175, 80, 0.4)',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #45a049 30%, #4CAF50 90%)',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 6px 20px rgba(76, 175, 80, 0.6)',
                          }
                        }}
                      >
                        JOIN
                      </Button>
                    )}
                  </Box>
                </Box>
                
                <Box p={3}>
                  {/* Search Box */}
                  <Box mb={3}>
                    <TextField
                      placeholder="Search by S.No, Name, or Mobile Number..."
                      value={this.state.searchTerm}
                      onChange={this.handleSearchChange}
                      fullWidth
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <Box sx={{ 
                            color: 'text.secondary', 
                            mr: 1,
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                            </svg>
                          </Box>
                        ),
                        style: {
                          height: '40px',
                          fontSize: '14px',
                          backgroundColor: '#f8f9fa',
                          borderRadius: '8px'
                        }
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&:hover': {
                            backgroundColor: '#e9ecef',
                          },
                          '&.Mui-focused': {
                            backgroundColor: 'white',
                            boxShadow: '0 0 0 2px rgba(102, 126, 234, 0.2)',
                          }
                        }
                      }}
                    />
                  </Box>

                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ color: 'primary.main' }}>
                    Confirmed Participants ({this.state.filteredNormalMembers ? this.state.filteredNormalMembers.length : 0})
                    {this.state.searchTerm && this.state.normalmembers && (
                      <Typography component="span" variant="body2" color="textSecondary" sx={{ ml: 1 }}>
                        (filtered from {this.state.normalmembers.length} total)
                      </Typography>
                    )}
                  </Typography>
                  
                  {this.state.filteredNormalMembers && this.state.filteredNormalMembers.length > 0 ? (
                    <Table columns={member_columns} rows={this.state.filteredNormalMembers} />
                  ) : this.state.searchTerm ? (
                    <Box textAlign="center" py={4}>
                      <Typography variant="body1" color="textSecondary">
                        No participants found matching "{this.state.searchTerm}"
                      </Typography>
                      <Button
                        variant="text"
                        onClick={() => this.setState({ searchTerm: '' })}
                        sx={{ mt: 1 }}
                      >
                        Clear search
                      </Button>
                    </Box>
                  ) : (
                    <Box textAlign="center" py={4}>
                      <Typography variant="body1" color="textSecondary">
                        No participants yet. Be the first to join!
                      </Typography>
                    </Box>
                  )}
                  
                  {this.state.filteredWlMembers && this.state.filteredWlMembers.length > 0 && (
                    <>
                      <Divider sx={{ my: 3 }} />
                      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ color: 'warning.main' }}>
                        Waiting List ({this.state.filteredWlMembers.length})
                        {this.state.searchTerm && this.state.wl_members && (
                          <Typography component="span" variant="body2" color="textSecondary" sx={{ ml: 1 }}>
                            (filtered from {this.state.wl_members.length} total)
                          </Typography>
                        )}
                      </Typography>
                      <Table columns={member_columns} rows={this.state.filteredWlMembers} />
                    </>
                  )}

                  {/* Description Section */}
                  {this.state.description && this.state.description.trim() !== '' && (
                    <Box mt={3} p={3} sx={{
                      backgroundColor: 'rgba(25, 118, 210, 0.05)',
                      borderRadius: '12px',
                      border: '1px solid rgba(25, 118, 210, 0.1)',
                    }}>
                      <Typography variant="h6" fontWeight="medium" color="dark" mb={2}>
                        Group Description
                      </Typography>
                      <Box 
                        sx={{
                          backgroundColor: '#fff',
                          p: 2,
                          borderRadius: '8px',
                          border: '1px solid rgba(0,0,0,0.1)',
                        }}
                      >
                        <div 
                          dangerouslySetInnerHTML={{ 
                            __html: this.state.description 
                          }}
                          style={{
                            lineHeight: '1.6',
                            color: '#333',
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                            fontFamily: 'inherit'
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>
              </Card>
            ) : this.state.viewstatus === 'create' ? (
              <Card id="join-form-container" sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box sx={{ background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)', p: 3 }}>
                  <Typography variant="h5" fontWeight="bold" color="white" textAlign="center">
                    Join Match
                  </Typography>
                </Box>
                
                <Box p={4}>
                  {this.state.storedIUserName && this.state.storedIUserName !== '' && this.state.show_link === '1' && (
                    <Box mb={3} p={2} bgcolor="success.light" borderRadius={2}>
                      <Typography variant="body2" color="success.dark">
                        Quick Join: <Button color="inherit" onClick={this.clickedAddMemberC}>
                          Add {this.state.storedIUserName}
                        </Button>
                      </Typography>
                    </Box>
                  )}
                  
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <SoftInput 
                        placeholder="Mobile Number" 
                        onKeyUp={this.onKeyDownSearch} 
                        name="j_mobile_no" 
                        id="j_mobile_no" 
                        inputProps={{ maxLength: 10 }}
                        fullWidth
                      />
                    </Grid>
                    
                    {(this.state.group_admin_flag === '1' || (this.state.show_join_link_group_members_only ==='0' || this.state.show_join_link_group_members_only ==='2')) && (
                      <Grid item xs={12} md={6}>
                        <SoftInput 
                          placeholder="Name" 
                          name="j_full_name" 
                          id="j_full_name" 
                          inputProps={{ maxLength: 60 }}
                          fullWidth
                        />
                      </Grid>
                    )}
                  </Grid>
                  
                  {/* Hidden input for member ID */}
                  <input type="hidden" id="j_member_id" />
                  
                  <Box id="j_members_list" mt={2} />
                  
                  {this.state.photo_upload === '1' && (this.state.group_admin_flag === '1' || this.state.selected_player_photo === '') && (
                    <Box mt={3}>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Upload Profile Picture (max 1MB)
                      </Typography>
                      <input 
                        type="file" 
                        accept="image/*" 
                        onChange={this.onFileChange}
                        style={{ fontSize: '14px', marginBottom: '10px' }}
                      />
                      
                      {this.state.imageSrc && (
                        <Box mt={2}>
                          <div style={{ 
                            border: '2px dashed #ddd', 
                            borderRadius: '8px', 
                            padding: '16px',
                            background: '#fafafa',
                            textAlign: 'center'
                          }}>
                            <div style={{ 
                              maxWidth: '100%', 
                              maxHeight: '400px',
                              margin: '0 auto',
                              position: 'relative',
                              borderRadius: '8px',
                              overflow: 'hidden'
                            }}>
                              <img 
                                src={this.state.imageSrc} 
                                alt="Upload preview"
                                style={{ 
                                  maxWidth: '100%', 
                                  maxHeight: '400px',
                                  display: 'block',
                                  margin: '0 auto',
                                  borderRadius: '8px'
                                }}
                              />
                            </div>
                            <Box mt={2}>
                              <Typography variant="body2" color="textSecondary" mb={2}>
                                Image uploaded successfully! ✅
                              </Typography>
                            </Box>
                          </div>
                        </Box>
                      )}
                      

                    </Box>
                  )}
                  
                  {(this.state.group_admin_flag === '1' || (this.state.show_join_link_group_members_only ==='0' || this.state.show_join_link_group_members_only ==='2')) && (
                    <Box mt={4}>
                      <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        onClick={this.onClickAddLink}
                        disabled={this.state.loader_join}
                        sx={{
                          background: 'linear-gradient(45deg, #4CAF50 30%, #45a049 90%)',
                          color: 'white',
                          fontSize: '1.1rem',
                          padding: '12px',
                          borderRadius: '8px',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #45a049 30%, #4CAF50 90%)',
                          }
                        }}
                      >
                        {this.state.loader_join ? <Spinner /> : 'Join Match'}
                      </Button>
                    </Box>
                  )}
                  
                  <Box display="flex" alignItems="center" mt={2}>
                    <Checkbox value="1" id="j_keep" />
                    <Typography variant="body2" color="textSecondary">
                      Need to add multiple? Tick this to keep the form.
                    </Typography>
                  </Box>
                  
                  <Box mt={3} textAlign="center">
                    <Button
                      variant="text"
                      onClick={this.backButtonClick}
                      sx={{ color: 'primary.main' }}
                    >
                      ← Back to list
                    </Button>
                  </Box>
                </Box>
              </Card>
            ) : this.state.viewstatus === 'uploaduserdp' ? (
              <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box sx={{ background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)', p: 3 }}>
                  <Typography variant="h5" fontWeight="bold" color="white" textAlign="center">
                    Change Profile Pic - {this.state.selected_member_name}
                  </Typography>
                </Box>
                
                <Box p={4}>
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Upload Profile Picture (max 1MB)
                  </Typography>
                  <input 
                    type="file" 
                    accept="image/*" 
                    onChange={this.onFileChange}
                    style={{ fontSize: '14px', marginBottom: '10px' }}
                  />
                  
                  {this.state.imageSrc && (
                    <Box mt={2}>
                      <div style={{ 
                        border: '2px dashed #ddd', 
                        borderRadius: '8px', 
                        padding: '16px',
                        background: '#fafafa',
                        textAlign: 'center'
                      }}>
                        <div style={{ 
                          maxWidth: '100%', 
                          maxHeight: '400px',
                          margin: '0 auto',
                          position: 'relative',
                          borderRadius: '8px',
                          overflow: 'hidden'
                        }}>
                          <img 
                            src={this.state.imageSrc} 
                            alt="Upload preview"
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '400px',
                              display: 'block',
                              margin: '0 auto',
                              borderRadius: '8px'
                            }}
                          />
                        </div>
                        <Box mt={2}>
                          <Typography variant="body2" color="textSecondary" mb={2}>
                            Image uploaded successfully! ✅
                          </Typography>
                        </Box>
                      </div>
                    </Box>
                  )}
                  

                  
                  <Box mt={4}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={this.ondMIImageChange}
                      sx={{
                        background: 'linear-gradient(45deg, #ff9800 30%, #f57c00 90%)',
                        color: 'white',
                        '&:hover': {
                          background: 'linear-gradient(45deg, #f57c00 30%, #ff9800 90%)',
                        }
                      }}
                    >
                      Update Photo
                    </Button>
                  </Box>
                  
                  <Box mt={3} textAlign="center">
                    <Button
                      variant="text"
                      onClick={() => this.setState({
                        viewstatus: 'list',
                        imageSrc: null,
                        croppedImage: null
                      })}
                      sx={{ color: 'primary.main' }}
                    >
                      ← Back to list
                    </Button>
                  </Box>
                </Box>
              </Card>
            ) : this.state.viewstatus === 'uploadusercricdp' ? (
              <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Box sx={{ background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)', p: 3 }}>
                  <Typography variant="h5" fontWeight="bold" color="white" textAlign="center">
                    Edit CricHeroes Profile - {this.state.selected_member_name}
                  </Typography>
                </Box>
                
                <Box p={4}>
                  <SoftInput 
                    type="text" 
                    name="micricdp_profile_pic_link" 
                    id="micricdp_profile_pic_link" 
                    placeholder="CricHeroes Profile link"
                    fullWidth
                  />
                  
                  <Box mt={4}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={this.ondMIICricmageChange}
                      sx={{
                        background: 'linear-gradient(45deg, #2196F3 30%, #1976D2 90%)',
                        color: 'white',
                        '&:hover': {
                          background: 'linear-gradient(45deg, #1976D2 30%, #2196F3 90%)',
                        }
                      }}
                    >
                      Update Profile Link
                    </Button>
                  </Box>
                  
                  <Box mt={3} textAlign="center">
                    <Button
                      variant="text"
                      onClick={() => this.setState({
                        viewstatus: 'list',
                        imageSrc: null,
                        croppedImage: null
                      })}
                      sx={{ color: 'primary.main' }}
                    >
                      ← Back to list
                    </Button>
                  </Box>
                </Box>
              </Card>
            ) : null}
          </SoftBox>
        </SoftBox>
        
        {/* Modals */}
        <Modal
          isOpen={this.state.show}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Modal"
        >
          <Box p={3}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Player Profile
            </Typography>
            <Button variant="outlined" onClick={this.closeModal} sx={{ mb: 2 }}>
              Close
            </Button>
            <div id='i_profile_modal'>Player profile</div>
          </Box>
        </Modal>

        <Modal
          isOpen={this.state.showVerify}
          onRequestClose={this.closeshowVerify}
          style={customStyles}
          shouldCloseOnOverlayClick={true}
          contentLabel="Modal"
        >
          <Box p={3}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Verify Removal
            </Typography>
            <Typography variant="body1" mb={3}>
              {this.state.pop_message}
            </Typography>
            
            <div id='i_remove_modal_click'>
              <Button
                variant="contained"
                onClick={this.onClickGenOTPR}
                sx={{ mb: 2 }}
              >
                Generate OTP
              </Button>
            </div>
            
            <div id='i_remove_modal_form' style={{display:"none"}}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Verify OTP (sometimes via SMS or sometimes via incoming call)
              </Typography>
              <SoftInput 
                type="text" 
                name="rem_otp" 
                id="rem_otp" 
                placeholder="Please enter OTP" 
                inputProps={{ maxLength: 4 }}
                fullWidth
                sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                fullWidth
                onClick={this.onRClickVerify}
              >
                Verify
              </Button>
            </div>
          </Box>
        </Modal>

        <Modal
          isOpen={this.state.showChangeType}
          onRequestClose={this.closeshowChangeType}
          style={customStyles}
          shouldCloseOnOverlayClick={true}
          contentLabel="Modal"
        >
          <Box p={3}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              {this.state.change_pop_message}
            </Typography>
            
            <Box mb={3}>
              <Typography variant="subtitle1" gutterBottom>
                Type:
              </Typography>
              <FormSelect size="sm" name="mi_member_type" id="mi_member_type" style={{ width: '100%', padding: '8px' }}>
                <option value="1" selected={(this.state.c_participant_member_type === "1") ? 'selected' : ''}>Normal</option>
                <option value="2" selected={(this.state.c_participant_member_type === "2") ? 'selected' : ''}>Guest</option>
              </FormSelect>
            </Box>
            
            <Box mb={3}>
              <Typography variant="subtitle1" gutterBottom>
                Icon?
              </Typography>
              <FormSelect size="sm" name="mi_is_icon" id="mi_is_icon" style={{ width: '100%', padding: '8px' }}>
                <option value="0" selected={(this.state.c_is_icon === "0") ? 'selected' : ''}>No</option>
                <option value="1" selected={(this.state.c_is_icon === "1") ? 'selected' : ''}>Yes</option>
              </FormSelect>
            </Box>
            
            <Box mb={3}>
              <SoftInput 
                placeholder="Icon Team Name" 
                name="mi_icon_text" 
                id="mi_icon_text" 
                onChange={this.handleChange} 
                value={this.state.c_icon_tex} 
                inputProps={{ maxLength: 100 }}
                fullWidth
              />
            </Box>
            
            <Button
              variant="contained"
              fullWidth
              onClick={this.onClickMChangeType}
              sx={{ mb: 2 }}
            >
              Update
            </Button>
            
            {this.state.group_admin_flag === '1' && (
              <Box mt={4}>
                <Divider sx={{ mb: 3 }} />
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Swap Player
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                    <SoftInput 
                      placeholder="Enter mobile number" 
                      name="mi_e_new_user_mobile_number" 
                      id="mi_e_new_user_mobile_number" 
                      inputProps={{ maxLength: 10 }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      variant="contained"
                      id="michangeswapplayer"
                      onClick={this.onClickSwapPlayerBeforeAuction}
                      fullWidth
                    >
                      Change Player
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        </Modal>

        <Footer />
      </DashboardLayout>
    )  
  }  
} 